import axios from "axios";
import { getAppParams } from "../utils/appParams";

let cachedUserToken = null;

function ensureAxiosHeaders() {
  if (!axios.defaults.headers) {
    axios.defaults.headers = {};
  }
  return axios.defaults.headers;
}

function persistToken(token, source = "unknown") {
  if (!token || typeof token !== "string") return null;
  cachedUserToken = token;
  const headers = ensureAxiosHeaders();
  headers["X-userToken"] = token;
  headers["X-UserToken"] = token;
  try {
    sessionStorage.setItem("sn_user_token", token);
  } catch (_) {
    /* ignore storage failures */
  }
  try {
    console.log(`[UserToken] Cached token from ${source}`);
  } catch (_) {
    /* noop */
  }
  return token;
}

function getTokenFromSessionStorage() {
  try {
    return sessionStorage.getItem("sn_user_token");
  } catch (_) {
    return null;
  }
}

function getTokenFromAxiosDefaults() {
  try {
    const headers = axios?.defaults?.headers;
    if (!headers) return null;
    return headers["X-userToken"] || headers["x-usertoken"] || null;
  } catch (_) {
    return null;
  }
}

function getTokenFromUrlParam() {
  try {
    if (typeof window === "undefined" || !window?.location?.search) return null;
    const params = getAppParams();
    // Accept multiple param names for the Smart Folders impersonation flow.
    // Primary/legacy: userToken
    const keys = [
      "userToken",
      "impersonationToken",
      "impersonation_token",
      "user_impersonation_token",
      "sn_user_token",
      "xUserToken",
      "x_user_token",
    ];
    for (const key of keys) {
      const v = params.get(key);
      if (v) return v;
    }
    return null;
  } catch (_) {
    return null;
  }
}

function resolveExistingToken({ includeUrl = false } = {}) {
  // If Smart Folders passed a user impersonation token on the URL, it should
  // override any previously cached/session token for this browser session.
  if (includeUrl) {
    const fromUrl = getTokenFromUrlParam();
    if (fromUrl) {
      console.log(
        "[UserToken] Hydrated token from URL parameter (Smart Folders impersonation)."
      );
      return persistToken(fromUrl, "urlParam");
    }
  }

  if (cachedUserToken) return cachedUserToken;

  const fromSession = getTokenFromSessionStorage();
  if (fromSession) return persistToken(fromSession, "sessionStorage");

  const fromAxios = getTokenFromAxiosDefaults();
  if (fromAxios) return persistToken(fromAxios, "axios.defaults");

  return null;
}

export function getCachedUserToken(options = {}) {
  const { includeUrl = false } = options;
  return resolveExistingToken({ includeUrl }) || null;
}

